import { DatePicker } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";

import calendar from "../assets/calendar.svg";
import locale from 'antd/es/date-picker/locale/es_ES';

interface IProps {
  save?: any;
  onChange?: any;
  dia?: string;
  mes?: string;
  anio?: string;
}

const DateInput: FC<IProps> = ({ save, onChange, dia, mes, anio }) => {
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    if (dia || dia === "") {
      setDay(dia);
    }
  }, [dia]);

  useEffect(() => {
    if (mes || mes === "") {
      setMonth(mes);
    }
  }, [mes]);

  useEffect(() => {
    if (anio || anio === "") {
      setYear(anio);
    }
  }, [anio]);

  const guardarFecha = (fecha: any) => {
    const formatted = moment(fecha).format("YYYY-MM-DD");
    setOpenDatePicker(false);
    setDay(moment(fecha).format("DD"));
    setMonth(moment(fecha).format("MM"));
    setYear(moment(fecha).format("YYYY"));
    save?.(formatted);
    onChange?.(formatted);
  };
  return (
    <div className="row g-2">
      <div className="col-3">
        <button type="button" onClick={() => setOpenDatePicker(!openDatePicker)}
          className="form-control font-family-Montserrat-Regular"
          style={{ borderRadius: "6px", color: "#ABAFB3" }}
        
         >
          {day || "DD"}
        </button>
      </div>
      <div className="col-3">
        <button type="button" onClick={() => setOpenDatePicker(!openDatePicker)}
          className="form-control font-family-Montserrat-Regular"
          style={{ borderRadius: "6px", color: "#ABAFB3" }}
        
         >
          {month || "MM"}
        </button>
      </div>
      <div className="col-5">
        <button type="button" onClick={() => setOpenDatePicker(!openDatePicker)}
          className="form-control font-family-Montserrat-Regular"
          style={{ borderRadius: "6px", color: "#ABAFB3" }}
        
         >
          {year || "AAAA"}
        </button>
      </div>
      <div className="col-1">
        <DatePicker
          locale={locale}
          style={{
            paddingLeft: 0,
            cursor: "pointer",
          }}
          className="font-size-20px font-color-051923bf datepicker-hidden"
          suffixIcon={<img style={{ cursor: "pointer" }} src={calendar} alt="" />}
          clearIcon={false}
          onClick={() => setOpenDatePicker(true)}
          bordered={false}
          open={openDatePicker}
          onChange={guardarFecha}
        />
      </div>
    </div>
  );
};

export default DateInput;
